import { useQuery } from '@tanstack/react-query';
import { team } from '../api/methods';
export const teamKeys = {
    all: ['team'],
    list: ['team', 'list'],
    dashboard: ['team', 'dashboard'],
    managerOverview: ['team', 'managerOverview'],
    corrections: (days) => ['team', 'corrections', days],
    memberCards: (memberId) => ['team', 'memberCards', memberId],
    memberDashboard: (memberId) => ['team', 'memberDashboard', memberId],
};
export function useTeamList(options) {
    return useQuery({
        queryKey: teamKeys.list,
        queryFn: () => team.list(),
        enabled: options?.enabled !== false,
    });
}
export function useTeamDashboard(options) {
    return useQuery({
        queryKey: teamKeys.dashboard,
        queryFn: () => team.dashboard(),
        enabled: options?.enabled !== false,
    });
}
/**
 * Manager dashboard payload — team table + open team tickets + manager's
 * own cards. Caller is responsible for gating with permissions.canViewTeam;
 * the endpoint returns 403 for non-managers.
 */
export function useManagerOverview(options) {
    return useQuery({
        queryKey: teamKeys.managerOverview,
        queryFn: () => team.managerOverview(),
        enabled: options?.enabled !== false,
    });
}
/**
 * Correction Loop weekly report — per-tech reviewer-kickback counts. Caller
 * gates with the manager capability; the endpoint 403s non-managers.
 */
export function useTeamCorrections(options) {
    const days = options?.days ?? 7;
    return useQuery({
        queryKey: teamKeys.corrections(days),
        queryFn: () => team.corrections({ days }),
        enabled: options?.enabled !== false,
    });
}
export function useTeamMemberCards(memberId, options) {
    return useQuery({
        queryKey: teamKeys.memberCards(memberId),
        queryFn: () => team.memberCards(memberId),
        enabled: !!memberId && options?.enabled !== false,
    });
}
export function useTeamMemberDashboard(memberId, options) {
    return useQuery({
        queryKey: teamKeys.memberDashboard(memberId),
        queryFn: () => team.memberDashboard(memberId),
        enabled: !!memberId && options?.enabled !== false,
    });
}
//# sourceMappingURL=useTeam.js.map